import * as React from "react";
import {
  AlignItemsType,
  JustifyContentType,
  SizeOption,
} from "../../utils/theme";
import { cx } from "../../utils/dom";
import { AsProps, ResponsiveProp } from "../../utils/types";
import { Box } from "../box";
import { breakpointClassNames } from "../../utils/helpers";
import { BoxProps } from "../box/box";

type Columns =
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "10"
  | "11"
  | "12"
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12;
interface GridProps {
  columns?: ResponsiveProp<Columns>;
  gap?: ResponsiveProp<SizeOption>;
  gapX?: ResponsiveProp<SizeOption>;
  gapY?: ResponsiveProp<SizeOption>;
  align?: ResponsiveProp<AlignItemsType>;
  justify?: ResponsiveProp<JustifyContentType>;
}

export const _Grid = <T extends React.ElementType = "div">(
  props: GridProps & BoxProps & AsProps<T>,
  ref: React.Ref<T>
) => {
  const {
    columns = 12,
    gap = "sm",
    gapX,
    gapY,
    align,
    justify,
    as,
    className,
    ...otherProps
  } = props;

  return (
    // TODO figure out why ts is screaming over here
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    <Box
      as={as}
      ref={ref}
      className={cx(
        "p-grid",
        "display-grid",
        breakpointClassNames("columns", columns),
        breakpointClassNames("gap", gap),
        breakpointClassNames("column-gap", gapX),
        breakpointClassNames("row-gap", gapY),
        breakpointClassNames("flex-align", align),
        breakpointClassNames("flex-justify", justify),
        className
      )}
      {...otherProps}
    ></Box>
  );
};

_Grid.displayName = "Grid";

export const Grid = React.forwardRef(_Grid) as typeof _Grid;

interface GridItemProps extends React.ComponentProps<typeof Box> {
  colSpan?: ResponsiveProp<Columns>;
}

export const _GridItem = <T extends React.ElementType = "div">(
  props: GridItemProps & AsProps<T>,
  ref: React.Ref<T>
) => {
  return (
    <Box
      ref={ref}
      className={cx(
        "p-grid-item",
        breakpointClassNames("col-span", props.colSpan),
        props.className
      )}
      {...props}
    ></Box>
  );
};

export const GridItem = React.forwardRef(_GridItem) as typeof _GridItem;
_GridItem.displayName = "GridItem";
